import {VStack} from 'platform/foundation';

import {
  PriceGroupCard,
  VehicleFormDefaultLayout,
  VehicleSubSections as VFSubSection,
} from '@dms/features/vehicle-forms-kit';

export function RentalInformation() {
  return (
    <VehicleFormDefaultLayout>
      <VehicleFormDefaultLayout.Left>
        <VStack spacing={4}>
          <VFSubSection.RentalInformation />

          <PriceGroupCard />
        </VStack>
      </VehicleFormDefaultLayout.Left>
    </VehicleFormDefaultLayout>
  );
}
